module.exports = __webpack_public_path__ + "media/images/pic/hero/mountain-55016436673ef9f5b839384e561545cc.png";